// reusable selectors for auth Slices
import { useSelector } from "react-redux";
import { IApp } from "redux/reducers/appSlice";
import { RootSliceType } from "redux/reducers/rootReducer";

const useAppSelectors = () => {
  const countryList = useSelector<RootSliceType, IApp["countryList"]>(
    (state) => state.app.countryList
  );

  const categoryList = useSelector<RootSliceType, IApp["categoryList"]>(
    (state) => state.app.categoryList
  );
  const alert = useSelector<RootSliceType, IApp["alert"]>(
    (state) => state.app.alert
  );
  const bottomBarAction = useSelector<RootSliceType, IApp["bottomBarAction"]>(
    (state) => state.app.bottomBarAction
  );
  const language = useSelector<RootSliceType, IApp["language"]>(
    (state) => state.app.language
  );
  const languageList = useSelector<RootSliceType, IApp["languageList"]>(
    (state) => state.app.languageList
  );
  const tagList = useSelector<RootSliceType, IApp["tagList"]>(
    (state) => state.app.tagList
  );
  const isOpenUseEDUBAModal = useSelector<
    RootSliceType,
    IApp["isOpenUseEDUBAModal"]
  >((state) => state.app.isOpenUseEDUBAModal);
  return {
    countryList,
    categoryList,
    alert,
    bottomBarAction,
    language,
    isOpenUseEDUBAModal,
    languageList,
    tagList
  };
};

export default useAppSelectors;
